import dayjs, { Dayjs } from 'dayjs';
import { CMS_PAGES } from './constants';

const SUNDAY = 0;
const SATURDAY = 6;

function setNonWeekends(date: Dayjs) {
  let newDate = date.clone();

  if (newDate.day() === SUNDAY) {
    newDate = newDate.add(1, 'days');
  } else if (newDate.day() === SATURDAY) {
    newDate = newDate.add(2, 'days');
  }

  return newDate;
}

export function getSuggestedTimeSlot() {
  const NUMBER_OF_PROPOSAL = 3;

  return Array.from({ length: NUMBER_OF_PROPOSAL }, (_, i) => i + 1)
    .reduce((result) => {
      const dateToAdd = result.length === 0 ? dayjs().add(7, 'days') : result[result.length - 1].add(1, 'days');

      return [...result, setNonWeekends(dateToAdd)];
    }, [] as Dayjs[])
    .map((d) => d.toDate());
}

export function getWordpressPageUrl(key: keyof typeof CMS_PAGES) {
  const currentLanguage = WISORY_SDK_SETTINGS.LOCALE || 'sv';

  return CMS_PAGES[key][currentLanguage as 'en' | 'sv'];
}
